import Alpine from 'alpinejs';

// Banner morph: time-driven cycle through three clip-path states for
// the video mask. Mirrors imageMorph's pattern (interval on init,
// destroy clears it) — the slogan word-group hovers no longer drive
// the state; they're presentation-only via SCSS now.
Alpine.data('bannerMorph', () => ({
  states: 3,
  current: 1,
  intervalId: null,

  init() {
    this.intervalId = setInterval(() => this.next(), 5000);
  },

  destroy() {
    if (this.intervalId) {
      clearInterval(this.intervalId);
      this.intervalId = null;
    }
  },

  next() {
    this.current = (this.current % this.states) + 1;
  }
}));
